<template>
  <Modal id="CompanyDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('role.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
        <DescriptionsItem :label="$t('role.field.id_rol')">{{data.idRol}}</DescriptionsItem>
        <DescriptionsItem :label="$t('role.field.id_dep')">{{data.departmentName}}</DescriptionsItem>
        <DescriptionsItem :label="$t('role.field.name')">{{data.name}}</DescriptionsItem>
              <DescriptionsItem :label="$t('department.field.approver_id')">{{data.approver}}</DescriptionsItem>
      <DescriptionsItem :label="$t('department.field.approver2_id')">{{data.approver2}}</DescriptionsItem>
        <DescriptionsItem :label="$t('role.field.remark')">{{data.remark}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "RoleDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>